module.exports = __webpack_public_path__ + "static/img/recruit_2021_logo_sp_pink.ca18c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/recruit_2021_logo_sp_pink.png
// module id = qrHJ
// module chunks = 0